import React, { useState } from 'react';
import { IAddContactFormProps } from '../interfaces/IAddContactFormProps';
import { IFetchDataState } from '../../../../store/IFetchDataState';
import { NewContactFormik } from '../subComponents/NewContactFormik';
import { LenderOrderContactForm } from './LenderOrderContactForm';
import { AddPreExistingLenderOrderContactForm } from './AddPreExistingLenderOrderContactForm';
import { lenderOrderPreExistingContactFormValidation } from '../../../../validation/order/LenderOrderPreExistingContactFormValidation';
import { lenderOrderContactFormValidation } from '../../../../validation/order/LenderOrderContactFormValidation';
import { ILenderUserData } from '../../../../types/lenders/ILenderUser';
import {
  eContactEnvironment,
  eContactType,
  getContactDuplicationMessage,
} from '../../../../utilities/contact/duplicationErrorMessage';

interface IAddLenderOrderContactFormProps extends IAddContactFormProps {
  preExistingLenderContacts: IFetchDataState<string, ILenderUserData[]>;
  onAddContact: (email: string) => void;
}

export const AddLenderOrderContactForm: React.FC<IAddLenderOrderContactFormProps> = ({
  onCancel,
  onSubmit,
  addFetchError,
  addFetchStatus,
  preExistingLenderContacts,
  onAddContact,
}) => {
  const [addPreExistingContact, setAddPreExistingContact] = useState(true);

  return (
    <NewContactFormik
      title={'New Lender Contact'}
      addFetchError={addFetchError}
      addFetchStatus={addFetchStatus}
      addPreExistingContact={addPreExistingContact}
      setAddPreExistingContact={setAddPreExistingContact}
      onCancel={onCancel}
      onSubmit={onSubmit}
      validationSchema={
        addPreExistingContact ? lenderOrderPreExistingContactFormValidation : lenderOrderContactFormValidation
      }
      duplicateMessage={getContactDuplicationMessage(eContactType.Lender, eContactEnvironment.Order)}
    >
      {addPreExistingContact ? (
        <AddPreExistingLenderOrderContactForm
          preExistingLenderContacts={preExistingLenderContacts}
          onAddContact={onAddContact}
        />
      ) : (
        <LenderOrderContactForm emailReadOnly={false} />
      )}
    </NewContactFormik>
  );
};
